import { noop } from 'lodash';
import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { upsertWorkExperiences } from '../apis/workExperience';
import { TemporaryWorkExperience, WorkExperienceUpsertRequest } from '../components/WorkExperience/shared/types';

/**
 * @param {object} props
 * @param {() => void} props.onSuccess
 * @param {() => void} props.onError
 */
export default ({ onSuccess = noop, onError = noop }) =>
    useMutation<WorkExperienceUpsertRequest, AxiosError, WorkExperienceUpsertRequest>(
        ({ workExperiences }) => upsertWorkExperiences({ workExperiences }),
        {
            onSuccess,
            onError,
        }
    );

export const createWorkExperienceUpsertRequestData = (
    workExperiences?: TemporaryWorkExperience[] | null
): WorkExperienceUpsertRequest => ({
    workExperiences:
        workExperiences?.map((experience) => ({
            title: experience.title,
            employmentType: experience.employmentType,
            company: experience.company,
            startDate: experience.startDate,
            endDate: experience.endDate,
            skills: experience.skills,
            description: experience.description,
        })) || [],
});
